import type { ReactNode } from 'react'

import type { FillCard, FillCheck } from '@/models/fillApplication'
import { CardChecks } from './CardChecks'
import { FillTabHeader } from './FillTabHeader'

interface FillTabSectionProps {
  card: FillCard
  title: string
  description?: ReactNode
  checks: FillCheck[]
  /** Locks the fields while the tab's Save and continue is saving them. */
  saving?: boolean
  action?: ReactNode
  /** The tab's cards. */
  children: ReactNode
}

/** A tab's title and missing items above its cards. */
export function FillTabSection({
  card,
  title,
  description,
  checks,
  saving,
  action,
  children,
}: FillTabSectionProps) {
  return (
    // tabIndex -1: a check whose field isn't on the page focuses the section instead.
    <section data-fill-card={card} tabIndex={-1} className="flex scroll-mt-24 flex-col gap-4 outline-none">
      <FillTabHeader title={title} description={description} action={action} />
      <CardChecks checks={checks} />
      {/* Shut while saving: a keystroke now would count as saved without having been sent. */}
      <fieldset disabled={saving} className="flex min-w-0 flex-col gap-4">
        {children}
      </fieldset>
    </section>
  )
}
